/* Load after scb-cart-utils.js. No Shopify secrets belong in this file. */
(() => {
  'use strict';
  const config = window.SCB_CONFIG || {};
  if (!config.enabled || !window.SCBUtils || window.SCB_BRIDGE_STARTED) return;
  window.SCB_BRIDGE_STARTED = true;
  const root = window.Shopify?.routes?.root || '/';
  const proxy = config.proxyPath || '/apps/payment-bridge';
  let busy = false;
  function message(text) {
    let box = document.getElementById('scb-message');
    if (!box) {
      box = document.createElement('div'); box.id = 'scb-message'; box.role = 'alert';
      Object.assign(box.style, {position:'fixed',bottom:'20px',left:'20px',right:'20px',zIndex:'2147483647',padding:'18px',background:'#172234',color:'#fff',borderRadius:'8px'});
      document.body.appendChild(box);
    }
    box.textContent = text;
  }
  async function json(url, options) {
    const response = await fetch(url, {...options, credentials: 'same-origin', cache: 'no-store'});
    let data;
    try { data = await response.json(); } catch { throw new Error('Checkout connection is unavailable. Please try again.'); }
    if (!response.ok) {
      if (data.expired) sessionStorage.removeItem('scb-attempt');
      throw new Error(data.error || data.message || 'Could not prepare checkout.');
    }
    return data;
  }
  async function start(mode, button) {
    if (busy) return;
    busy = true;
    const previous = button?.getAttribute('aria-busy');
    const previousOpacity = button?.style.opacity;
    const previousCursor = button?.style.cursor;
    document.getElementById('scb-message')?.remove();
    button?.setAttribute('aria-busy', 'true');
    if (button) { button.style.opacity = '0.65'; button.style.cursor = 'progress'; }
    try {
      let items;
      if (mode === 'cart') {
        const cart = await json(root + 'cart.js');
        SCBUtils.assertCart(cart);
        items = cart.items.map(x => ({variant_id: String(x.variant_id), quantity: x.quantity}));
      } else {
        const form = button.form || (button.dataset.scbForm && document.getElementById(button.dataset.scbForm)) || button.closest('form');
        if (!form) throw new Error('Buy now needs the product form ID.');
        const data = new FormData(form);
        if (data.get('selling_plan') || [...data.keys()].some(k => k.startsWith('properties['))) throw new Error('This product option is not supported by this checkout yet.');
        const id = String(data.get('id') || '');
        const quantity = Number(data.get('quantity') || 1);
        if (!/^\d+$/.test(id) || !Number.isInteger(quantity) || quantity < 1) throw new Error('Choose a product option and quantity.');
        items = [{variant_id: id, quantity}];
      }
      const fingerprint = JSON.stringify({mode, items});
      let attempt;
      try { attempt = JSON.parse(sessionStorage.getItem('scb-attempt')); } catch {}
      if (!attempt || attempt.fingerprint !== fingerprint || Date.now() - attempt.at > 25 * 60 * 1000) {
        attempt = {id: crypto.randomUUID(), fingerprint, at: Date.now()};
        sessionStorage.setItem('scb-attempt', JSON.stringify(attempt));
      }
      const result = await json(proxy + '/start', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({request_id:attempt.id, mode, items, source:location.origin + location.pathname})});
      const target = new URL(result.url);
      if (target.origin !== config.checkoutOrigin || target.protocol !== 'https:') throw new Error('Unexpected checkout address. Contact the store.');
      location.assign(target.href);
    } catch (error) { message(error.message); }
    finally {
      busy = false;
      if (button) {
        previous === null ? button.removeAttribute('aria-busy') : button.setAttribute('aria-busy', previous);
        button.style.opacity = previousOpacity;
        button.style.cursor = previousCursor;
      }
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-scb-buy-now],[data-scb-checkout]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    start(button.hasAttribute('data-scb-buy-now') ? 'buy' : 'cart', button);
  }, true);
  // Enter-key submissions and ordinary cart-page checkout buttons.
  document.addEventListener('submit', event => {
    const form = event.target;
    const action = new URL(form.action || location.href, location.href).pathname;
    if (!action.endsWith('/cart') && !action.endsWith('/checkout')) return;
    if (!event.submitter?.matches('[name="checkout"],[data-scb-checkout]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    start('cart', event.submitter);
  }, true);
  // Standard cart buttons are marked without altering Add to cart controls.
  function mark() {
    document.querySelectorAll('button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href$="/checkout"]').forEach(el => { el.dataset.scbCheckout = ''; });
  }
  mark();
  const observer = new MutationObserver(mark);
  observer.observe(document.body, {childList:true, subtree:true});
  if (document.querySelector('[data-scb-return]')) {
    (async () => {
      const box = document.querySelector('[data-scb-return]');
      const params = new URLSearchParams(location.hash.slice(1));
      const order = params.get('scb_order'); const proof = params.get('scb_proof');
      if (!order || !proof) { box.textContent = 'Use the confirmation link from your checkout or email.'; return; }
      // Strip the bearer proof from the address bar before loading anything else.
      history.replaceState(null, '', location.pathname);
      try {
        const result = await json(proxy + '/result', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({order,proof})});
        if (result.state !== 'synced') { box.textContent = result.message || 'Your confirmation is being prepared. Please check your email shortly.'; return; }
        const target = new URL(result.url);
        const allowed = [location.hostname, config.shopDomain, config.accountHost].filter(Boolean);
        if (target.protocol !== 'https:' || !allowed.includes(target.hostname)) throw new Error('Please use the order-status link in your confirmation email.');
        const key = 'scb-cleared-' + order;
        // Browser storage can be blocked. Confirmation must still open; preserve the cart then.
        let canClearCart = false;
        try { localStorage.setItem('scb-storage-check', '1'); localStorage.removeItem('scb-storage-check'); canClearCart = !localStorage.getItem(key); } catch {}
        if (result.mode === 'cart' && canClearCart) {
          // A cross-tab browser lock plus a durable marker avoids repeated cart subtraction.
          const clear = async () => {
            if (localStorage.getItem(key)) return;
            const cart = await json(root + 'cart.js');
            const updates = SCBUtils.remainingUpdates(cart, result.items);
            // Write before updating: uncertain network results must never subtract twice.
            localStorage.setItem(key, 'attempted');
            if (Object.keys(updates).length) await json(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})});
            localStorage.setItem(key, 'done');
          };
          // Preserve the cart on older browsers without cross-tab locking.
          if (navigator.locks) { try { await navigator.locks.request('scb-cart-clear', clear); } catch {} }
        }
        try { sessionStorage.removeItem('scb-attempt'); } catch {}
        box.textContent = 'Order confirmed. Opening your order details…';
        location.replace(target.href);
      } catch (error) { box.textContent = error.message; }
    })();
  }
})();
